var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0616 3.87563C9.02402 4.46918 7.21262 5.66308 5.86373 7.30156C4.51485 8.94005 3.69112 10.947 3.5 13.0607H8.3192C8.60012 9.84428 9.53268 6.71865 11.0601 3.87412L11.0616 3.87563ZM8.3192 14.9432H3.5C3.69072 17.057 4.5141 19.0642 5.86272 20.7029C7.21134 22.3417 9.02257 23.5359 11.0601 24.1298C9.53268 21.2853 8.60012 18.1597 8.3192 14.9432ZM13.4757 24.5319C11.6498 21.636 10.5304 18.3514 10.2077 14.9432H17.7904C17.4678 18.3514 16.3483 21.636 14.5224 24.5319C14.1737 24.5492 13.8244 24.5492 13.4757 24.5319ZM16.9395 24.1283C18.9769 23.5345 20.7879 22.3405 22.1365 20.702C23.4851 19.0636 24.3086 17.0567 24.4997 14.9432H19.6805C19.3995 18.1597 18.467 21.2853 16.9395 24.1298V24.1283ZM19.6805 13.0607H24.4997C24.3089 10.947 23.4856 8.93978 22.1369 7.30102C20.7883 5.66226 18.9771 4.46802 16.9395 3.87412C18.467 6.71865 19.3995 9.84428 19.6805 13.0607ZM13.4757 3.47202C13.8249 3.45464 14.1747 3.45464 14.5239 3.47202C16.3493 6.36803 17.4682 9.65263 17.7904 13.0607H10.2092C10.536 9.63156 11.658 6.34396 13.4757 3.47202Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web_icon.94f8107c2fadbfe9846cc24ca6c5f37a.svg";
export { ForwardRef as ReactComponent };